import { render, staticRenderFns } from "./CustomTable.vue?vue&type=template&id=a22e8e64&"
import script from "./CustomTable.vue?vue&type=script&lang=js&"
export * from "./CustomTable.vue?vue&type=script&lang=js&"
import style0 from "./CustomTable.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports